var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('toolbar',[_c('h2',[_c('i',{staticClass:"fa fa-handshake"}),_vm._v(" Collective Agreements")]),_c('div',{staticClass:"controls"})]),_c('collective-agreements-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }